export const filterTypes = {
  course: 'COURSE',
  course_module: 'COURSE_MODULE',
  folder: 'FOLDER',
  status: 'STATUS',
}

export const DESIRED_MAX_COURSES_COUNT = 5
export const ITEMS_PER_PAGE = 20

